import { ParticleBackground } from "./ParticleBackground";

export const Website = () => {
    return (
        <div className="website">
            <ParticleBackground />
            <div className="main">
                <h1>
                    Вы заробатываете,
                    <br /> Мы говорим сколько
                </h1>
                <p>Мы предоставляем удобный и надёжный сервис для отслеживания доходов, связанный со всеми вашими операциями обмена криптовалют. Контролируйте свои финансовые потоки, анализируйте прибыль и получайте полную картину своих криптовалютных активов в одном месте.</p>
                <div className="btns">
                    <div className="btn1">Присоеденится</div>
                    <div className="btn2">Узнать больше</div>
                </div>
            </div>
            {/* <img src="/img/history.png" alt="" /> */}
        </div>
    );
};
